import { Link } from "react-router-dom";
import '../../assets/global.css';
import logo from '../../assets/Recurso 1.svg';

export default function LogoInicio (){
    return(
        <Link to="/"><img className="logo" src={logo} alt="Logo" /></Link>
    )
}